export const signalToTimeout = (timeoutMs: number, originalSignal?: AbortSignal) => {
  const controller = new AbortController();
  setTimeout(() => controller.abort(), timeoutMs);

  if (originalSignal) {
    return AbortSignal.any([originalSignal, controller.signal]);
  }
  return controller.signal;
};
